import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
export default function Demo() {
  const { id, pass } = useParams();
  const [isloading, setIsLoading] = useState(true);
  function FetchData() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      userId: 2,
      email: "user@example.com",
      firstName: "John",
      lastName: "Doe",
      birthdate: "1986-08-09",
      phoneNumber: "+12025550119",
      addressLine1: "128 Developers Blvd.",
      addressLine2: "Apt. 5, Suite 5A-1204",
      city: "Las Vegas",
      state: "NV",
      country: "US",
      zipCode: "90210",
      ssn: "001-02-0005",
      occupation: "Teacher",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://dev-api.bettgaming.us:9091/api/payment/enroll",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  }
  return (
    <div>
      <h1>User id is {id}</h1>
      <body>
        <p>Password is {pass}</p>
      </body>
      {isloading && (
        <div className="spintarget">
          <>
            <Spinner animation="border" variant="light" />
          </>
        </div>
      )}

      <></>
    </div>
  );
}
